import { observable, action, runInAction } from 'mobx';
import { backendServer } from '../../variable';
import { get, post } from '../../utils/fetch';
import { errorHandler } from '../../utils/methods';

class TradeStore {
  @observable
  isLoading = false;

  @observable
  ticketInfo = {}; // 发票信息

  /**
   * 获取要发送短信的发票信息
   * @param {Object} ticketInfo 发票信息
   */
  @action
  updateTicketInfo = ticketInfo => {
    this.ticketInfo = {
      ...ticketInfo,
      expressName: '',
      expressNumber: ''
    };
  };

  @action
  updateTicketInfoExpressName = expressName => {
    this.ticketInfo.expressName =  expressName;
  };

  @action
  updateTicketInfoExpressNumber = expressNumber => {
    this.ticketInfo.expressNumber = expressNumber;
  };

  /**
   * 发送短信
   * @param expressName 快递公司名称
   * @param expressNumber 快递号
   */
  @action
  sendMessage = async ({ id, expressName, expressNumber }) => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await post(`${backendServer}/agent/invoice/sms/notify`, { invoiceId: id, expressName, expressNumber });
      runInAction(() => {
        this.isLoading = false;
      });
      return response;
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
      });
      return errorHandler(err, '发送短信');
    }
  }

  /**
   * 获取物流相关信息
   * @param invoiceId 发票id
   */
  @action
  getLogistics = async (invoiceId) => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await get(`${backendServer}/agent/invoice/detail`, { invoiceId });
      runInAction(() => {
        this.isLoading = false;
        this.ticketInfo = {
          ...this.ticketInfo,
          expressName: response.data.expressName,
          expressNumber: response.data.expressNumber
        }
      });
      return response;
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
      });
      return errorHandler(err, '获取物流信息');
    }
  }
}

const tradeStore = new TradeStore();
export default tradeStore;


// WEBPACK FOOTER //
// ./src/stores/ticketStore/index.js